export const BG_PRIMARY = 'rgba(159,159,157,1)';
export const BG_PRIMARY_GRADIENT = 'rgba(15,10,10,1)';
export const BG_SECONDARY_GRADIENT = 'rgba(154,154,154,1)';
export const BG_SECONDARY = 'rgba(173,173,173,1)';

// color text
export const TEXT_PRIMARY = '#fff';
export const TEXT_SECONDARY = 'rgba(255,255,255,1)';
export const TEXT_ALTERNATIVE = '#5B341E';

export const TEXT_SHADOW = 'rgba(255,255,255,1)';

// music & navigation
export const NAVIGATION_COLOR = '#282724ff';
export const ICON_NAVIGATION_COLOR = '#fff';

// DEFAULT BUTTON PROPS
export const BUTTON_GRADIENT = `linear-gradient(to right, var(--chakra-colors-bgPrimaryGradient), var(--chakra-colors-bgSecondary) 200%)`;
export const BUTTON_PROPS = {
  _active: { borderColor: 'transparent' },
  _hover: { borderColor: 'transparent' },
  _focus: { borderColor: 'transparent' },
};
export const DEFAULT_BOTTOM = {
  color: 'mainColorText',
  boxShadow: 'xl',
  fontSize: '14px',
  fontWeight: 'light',
  borderRadius: '6px',
  size: 'sm',
  background: BUTTON_GRADIENT,
  ...BUTTON_PROPS,
};

export const DEFAULT_BUTTON_PROPS = {};
